import styled from 'styled-components';
import {
  Wrapper as Title
} from 'components/_utils/PageTitle/Styles'
import { UserInfoWidth } from 'defs/Constans';

export const Content = styled.section`

`;

export const List = styled.div`
  margin: 0 3.2rem;
  display: flex;
  flex-direction: column;
  gap: .8rem;
  ${Title} {
    margin-bottom: .8rem;
  }
`;

export const Items = styled.div`
  display: grid;
  grid-template-columns: 1fr 0rem;
  transition: .5s;

  &.open {
    grid-template-columns: 1fr ${UserInfoWidth};
  }
`;